import { isPlatform, getPlatforms } from '@ionic/vue';
import authStore from "@/framework/auth/AuthStore";

export const CODE_VERIFIER_KEY = 'cognito-code-verifier';
export const STATE_KEY = 'cognito-state';
export const CLIENT_ID = '7oqpqksnif4tbbptf3u54cdsbe';
export const COGNITO_URL = 'https://aristotle.auth.us-east-2.amazoncognito.com';

export function getAppClientId(): string {
    return process.env.VUE_APP_CLIENT_ID;
}

export function getRedirectHost(): string{ 
    // for local development on an emulator desktop returns true
    if((isPlatform('android') || isPlatform('ios')) && !isPlatform('mobileweb')) {
        return 'aristotle:/';
    }
    const port = window.location.port==='443'?':443':''
    return `${window.location.protocol}//${window.location.host}${port}`;
}

export function getRedirectUrl(): string {
    return `${getRedirectHost()}/logged-in`;
}

export function getBaseOauthUrl(): string {
    return getCognitoUrl() + '/oauth2';
}

function getCognitoUrl() {
    return process.env.VUE_APP_COGNITO_URL;
}

export function getLoginUrl(state: string, codeChallenge: string) {
    const baseUrl = getBaseOauthUrl() + '/authorize';
    const clientId = getAppClientId();
    const redirectUrl = getRedirectUrl();

    let scopes = 'openid email';
    // admin scope is necessary to allow the user to change their Cognito password
    scopes += ' aws.cognito.signin.user.admin';

    return encodeURI(`${baseUrl}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=${state}&scope=${scopes}&code_challenge_method=S256&code_challenge=${codeChallenge}`);
}

export function getForgotPasswordUrl(state: string, codeChallenge: string):string {
    const baseUrl = getCognitoUrl() + '/forgotPassword';
    const clientId = getAppClientId();
    const redirectUrl = getRedirectUrl();


    let scopes = 'openid email';
    // admin scope is necessary to allow the user to change their Cognito password
    scopes += ' aws.cognito.signin.user.admin';

    return encodeURI(`${baseUrl}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrl}&state=${state}&scope=${scopes}&code_challenge_method=S256&code_challenge=${codeChallenge}`);
}

export function gotoLogout() {
    window.location.href = getLogoutUrl();
}

function getLogoutUrl(): string {
    const loginUrl = getRedirectHost() + '/login';
    return `${getCognitoUrl()}/logout?client_id=${getAppClientId()}&logout_uri=${loginUrl}`;
}
